import { CouponTypeEnum } from 'common/enums/CouponTypeEnum'
import { usePayment } from 'publisher/store'
import { getCheckedCoupon } from 'publisher/store/payment/paymentSelectors'
import { useMemo } from 'react'
import { useOfferPricing } from 'src/publisher/hooks/use-offer-pricing'

export const useIsHundredPercentDiscount = (): boolean => {
  const coupon = usePayment(getCheckedCoupon)
  const { selectedOfferPricing } = useOfferPricing()

  return useMemo(() => {
    return (
      (coupon?.discountType === CouponTypeEnum.Percent &&
        coupon?.discountAmount === 100) ||
      (coupon?.discountType === CouponTypeEnum.Fixed &&
        coupon?.discountAmount >= (selectedOfferPricing?.originalAmount ?? 0))
    )
  }, [coupon, selectedOfferPricing])
}
